import InfoProducts from "./InfoProducts"
export default InfoProducts